const icon = require('vue-svgicon');
icon.register({
    'copy': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14.222 11.555H5.333a.889.889 0 01-.888-.888v-8.89c0-.49.398-.888.888-.888h8.89c.49 0 .888.398.888.889v8.889a.889.889 0 01-.889.888zm0-9.333a.445.445 0 00-.444-.444h-8c-.245 0-.445.199-.445.444v8c0 .246.2.445.445.445h8a.444.444 0 00.444-.445v-8zM1.778 13.778v-8c0-.246.199-.445.444-.445h1.334v-.888H1.778a.889.889 0 00-.889.888v8.89c0 .49.398.888.889.888h8.889c.49 0 .889-.398.889-.889v-1.777h-.89v1.333c0 .245-.198.444-.444.444h-8a.444.444 0 01-.444-.444z" _fill="#000"/>`,
    },
});
